'use strict';

module Patersons {

    export interface SetPasswordScope extends ng.IScope {
        setPasswordDetails: Patersons.SetPasswordDetails;
        setPasswordForm: ng.IFormController;
        errorHandler: any;
        isSubmitted: boolean;
        isSuccess: boolean;
        events: Patersons.SetPasswordCtrl;
        isLoading: boolean;
        
        passwordInputType: string;
        isValidPassword: boolean;
    }

    export class SetPasswordCtrl {

        scope: Patersons.SetPasswordScope;
        identityService: Patersons.IdentityService;
        tokenService: TokenService;

        static $inject = ['$scope', 'identityService', 'tokenService'];

        constructor($scope, identityService, tokenService) {
            this.scope = $scope;
            this.identityService = identityService;
            this.tokenService = tokenService;

            this.scope.events = this;
            this.scope.isSubmitted = false;
            this.scope.isSuccess = false;
            this.scope.passwordInputType = "password";
            this.scope.setPasswordDetails = new Patersons.SetPasswordDetails();
        }
        onValidation = (isValid: boolean) => {
            if(this.scope){
                this.scope.isValidPassword = isValid;
            }
        }
        togglePasswordVisibility() {
            
            if (this.scope.passwordInputType === "password") {
                this.scope.passwordInputType = "text"
            } else {
                this.scope.passwordInputType = "password"
            }
        }
        save() {
            this.scope.errorHandler = null;
            this.scope.isSubmitted = true;
            this.scope.$broadcast('show-errors-check-validity');

            if (this.scope.setPasswordForm.$invalid) {
                return;
            }
            this.scope.isLoading = true;
            this.identityService.setPassword(this.scope.setPasswordDetails)
                .then((result) => {
                    this.scope.isSuccess = true;
                    this.sleep(2000).then(() => {
                        this.tokenService.tokenManager.redirectForToken();
                    });
                }, (response) => {
                    this.scope.isSuccess = false;
                    this.scope.errorHandler = response.data;
                }).finally(() => {
                    this.scope.isLoading = false;
                });
        }

        sleep(time) {
            return new Promise((resolve) => setTimeout(resolve, time));
        }
    }
}